import {
  Currency,
  Discount,
  Frequency,
  ProductPricing,
  ProductPricingRules,
  ProductPricingType,
} from '@galaxy/billing';
import { MarketplaceBillingFrequency } from '../display.price';
import { BillingModel } from './billing-model';
import { ProductCategory } from './product-category';

/**
 * @deprecated: Combine Product and ProductPricing from billing instead.
 **/
export interface BilledProduct {
  productName: string;
  productId: string;
  billingModel: BillingModel;
  price: number;
  notes: (Discount | BundledProduct)[];
  iconURL: string;
  currency: Currency;
  billingFrequency: MarketplaceBillingFrequency;
  pricingTiers: PricingTier[];
  productCategory: ProductCategory;
  count?: number;
  commitment?: Commitment;
  setupFee: number;
}

/**
 * @deprecated: Use PricingRule instead
 **/
export interface PricingTier {
  rangeMin: number;
  rangeMax: number;
  price: number;
  isStartingPrice?: boolean;
}

/**
 * @deprecated: Use pricing's Commitment instead
 **/
export interface Commitment {
  initial: number;
  recurring: number;
}

export interface BundledProduct {
  productName: string;
}

export function pricingTypeToBillingModel(pricingType: ProductPricingType): BillingModel {
  switch (pricingType) {
    case ProductPricingType.Stairstep:
      return BillingModel.Stairstep;
    case ProductPricingType.Tiered:
      return BillingModel.Tiered;
    case ProductPricingType.Standard:
      return BillingModel.Standard;
  }
  return BillingModel.Standard;
}

export function pricingRulesToTiers(rules: ProductPricingRules[]): PricingTier[] {
  return rules.map((r) => {
    return {
      rangeMin: r.minUnits,
      rangeMax: r.maxUnits,
      price: r.price || 0,
    };
  });
}

export function mapFrequency(frequency: Frequency): MarketplaceBillingFrequency {
  switch (frequency) {
    case Frequency.OneTime:
      return MarketplaceBillingFrequency.OneTime;
    case Frequency.Monthly:
      return MarketplaceBillingFrequency.Monthly;
    case Frequency.Yearly:
      return MarketplaceBillingFrequency.Yearly;
  }
  return undefined as unknown as MarketplaceBillingFrequency;
}

export function buildBilledProductFromProductPricingAndAddon(
  addon: { productName: string; addonId: string; productIcon: string },
  productPricing: ProductPricing,
): BilledProduct {
  return {
    productName: addon.productName,
    productId: addon.addonId,
    billingModel: pricingTypeToBillingModel(productPricing.pricingType),
    price: undefined as unknown as number,
    notes: [],
    iconURL: addon.productIcon,
    currency: productPricing.currency,
    billingFrequency: mapFrequency(productPricing.frequency),
    pricingTiers: pricingRulesToTiers(productPricing.pricingRules),
    productCategory: undefined as unknown as ProductCategory,
    commitment: productPricing.commitment,
    setupFee: productPricing.setupFee,
  };
}
